import React from 'react';
import DataColumn from 'components/components/DataColumns/components/DataColumn';
import { ServicesType } from 'types/services';
import ServiceOfferedDocView from './View';

const ServiceDocuments = ({ details }: { details: ServicesType }) => (
  <>
    <DataColumn label="Rate Card Document">
      <ServiceOfferedDocView altText="No Rate Card Document available for this service provider" fileContent={details.serviceProvider?.companyDeck || ''} />
    </DataColumn>
    {typeof details.offerDocLink === 'string' && details.offerDocLink && (
      <DataColumn label="Offer Document">
        <ServiceOfferedDocView altText="No Offer Document available for this service" fileContent={details.offerDocLink} />
      </DataColumn>
    )}
  </>
);

export default ServiceDocuments;
